import StandardComponent from './StandardComponent.vue'

export default StandardComponent
